import { Component, OnInit } from '@angular/core';
import { overlayConfigFactory, Modal } from 'ngx-modialog';
import { BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { ApiService } from '../../../utils/services/api.service';
import { RoomModalComponent } from './room-modal/room-modal.component';

@Component({
  selector: 'app-room-changes',
  templateUrl: './room-changes.component.html',
  styleUrls: ['./room-changes.component.scss']
})
export class RoomChangesComponent implements OnInit {
  rooms = [];
  room = false

  constructor(public apiService: ApiService, public modal: Modal) { }

  ngOnInit() {
    this.getPendingRooms()
  }

  getPendingRooms() {
    this.apiService.getRoomChanges().subscribe(res => {
      if (res.data) {
        this.rooms = res.data
        this.room = true
        return this.rooms;
      }

    })
  }

  setApprove(room, hotelId, status) {
    let dialogRef = this.modal.open(
      RoomModalComponent,
      overlayConfigFactory({
        size: 'md',
        hotelId: hotelId,
        room: room,
        status: status == 'reject' ? 'Rejected' : 'Accepted',
        isAgencyView: true
      }, BSModalContext));
    dialogRef.result.then((result) => {
      if (result) {
        result.forEach((response) => {
          if (response) {
            console.log('ozge')
          }
        });
      }
    });
  }

}


// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/room-changes/room-changes.component.ts